import BusinessLayout from './BusinessLayout.jsx';

export {
  BusinessLayout
}


// WEBPACK FOOTER //
// ./components/layouts/business/index.js